<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">抓取经纬度</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">

              <baidu-map :center="center" :zoom="mapZoom" @ready="handler"
                  :scroll-wheel-zoom="true" @click="getClickInfo">

                  <bm-view style="width: 100%; height:400px;"></bm-view>

                  <bm-marker :position="{ lng: centerStr.lng, lat: centerStr.lat }"></bm-marker>

                  <bm-control :offset="{ width: '10px', height: '10px'}">
                      <bm-auto-complete v-model="addressInfo" :sugStyle="{ zIndex: 999999 }">
                          <el-input v-model="addressInfo" placeholder="输入关键字" style="margin:10px">
                              <template slot="prepend"><span>搜索：</span></template>
                          </el-input>
                      </bm-auto-complete>
                  </bm-control>

                  <bm-local-search :keyword="addressInfo" :auto-viewport="true"
                                   :pageCapacity="1" @searchcomplete="searchcomplete"
                                   style="width:0px;height: 0px;"></bm-local-search>

              </baidu-map>

            </div>
            <div class="modal-footer">

              <el-input v-model="centerStr.lng" disabled style="float:left;width: 200px;margin-right: 20px;">
                <template slot="prepend"><span>经度：</span></template>
              </el-input>

              <el-input v-model="centerStr.lat" disabled style="float:left;width: 200px;margin-right: 20px;">
                <template slot="prepend"><span>纬度：</span></template>
              </el-input>

              <el-button style="float: right;margin-right:10px" type="primary" @click="confirm('addForm')">选择</el-button>

            </div>
        </div>
    </div>
</template>

<script>

import BaiduMap from 'vue-baidu-map/components/map/Map.vue'

export default {
    name: "addHospital",
    data() {
        return {

          mapZoom: 12,

          addressInfo:'',

          center:{
            lng: 116.413387,
            lat: 39.901183
          },

          centerStr: {
            lng: "",
            lat: ""
          },

          bMap:null,
          map:null,

        };
    },
    components: {
        BaiduMap
    },
    methods: {
      closeSelf(){
          this.$emit('closeMap')
      },

      getClickInfo(e) {
          this.centerStr.lng = e.point.lng;
          this.centerStr.lat = e.point.lat;
      },

      searchcomplete(e) {
        let that = this;
        this.$nextTick(() => {
            if (e && e.Hr && e.Hr[0]) {
              var allOverlay = that.map.getOverlays();
              that.map.removeOverlay(allOverlay[allOverlay.length - 1]);
            }
        });
      },

      init(){

        this.mapZoom = 12;

        this.addressInfo='';
        this.centerStr = {
          lng: "",
          lat: ""
        };

        let that = this;

        // 异步执行, 是为了视图能对数据变化做出反应, 否则无法实现效果
        setTimeout(() => {

          that.center = {
            lng: 116.413387,
            lat: 39.901183
          };

        }, 1000);

      },

      init2(lon,lat){

        this.mapZoom = 12;

        this.addressInfo='';
        this.centerStr = {
          lng: lon,
          lat: lat
        };


        let that = this;
        // 异步执行, 是为了视图能对数据变化做出反应, 否则无法实现效果
        setTimeout(() => {

          that.center = {
            lng: lon,
            lat: lat
          };

        }, 1000);

      },

      handler({ BMap, map }){
        this.bMap=BMap;
        this.map=map;
      },

      confirm(){

          if(this.centerStr.lng == ''){
              this.$message({type: 'info', message: '请抓取经纬度'});
              return;
          }

          var mapCenter={
              lng: this.centerStr.lng, lat:this.centerStr.lat
          }
          //console.log(mapCenter)
          this.$emit('setMap',mapCenter)
      }

  }
};

</script>
<style lang="scss" scoped>


</style>
